import PolesMetiersRelated from './polesMetiersRelated';
import SiteImageActions from './siteImageActions';
import SiteLocalisation from './siteLocalisation';
import { Box, Grid } from '@mui/material';
import '../../../css/sites/siteDetailsContent.css';

const SiteDetailsContent = () => {
  return (
    <Grid container spacing={3} className='siteDetailsContent_main_grid'>
      <Grid item xs={12} md={4} padding={3}>
        <Box className='siteDetailsContent_image_chiffre_box'>
          <SiteImageActions />
        </Box>
      </Grid>
      <Grid item xs={12} md={8} padding={3} >
        <Box className='siteDetailsContent_second_grid_box'>
          <SiteLocalisation />
        </Box>
      </Grid>
      <Grid item xs={12} md={12} padding={3} >
        <Box className='siteDetailsContent_second_grid_box'>
          <PolesMetiersRelated />
        </Box>
      </Grid>
    </Grid>
  );
}

export default SiteDetailsContent;